<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <v-row>
      <v-col>
        <v-text-field v-model="view_record.search_value" label="Search ..." append-icon="fas fa-search" outlined style="margin: 0 0 -30px 0;"></v-text-field>
      </v-col>
      <v-col md="12">
        <v-card elevation="4">
          <v-card-title>
            View Import Record
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table :headers="view_record.import_record_headers" :items="import_record_items" :items-per-page="5" class="elevation-1">
              <template v-slot:item.last_open_date="{ item }">
                {{new Date(item.last_open_date).getFullYear() + '-' + (new Date(item.last_open_date).getMonth() + 1) + '-' + new Date(item.last_open_date).getDate()}}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card elevation="4">
          <v-card-title>
            View Exist User
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table :headers="view_record.user_header" :items="users_items" :items-per-page="5" class="elevation-1">
              <template v-slot:item.dob="{ item }">
                {{new Date(item.dob).getFullYear() + '-' + (new Date(item.dob).getMonth() + 1) + '-' + new Date(item.dob).getDate()}}
              </template>
              <template v-slot:item.edit="{ item }">
                <v-icon small @click="editData(item, 'Client')">{{item.edit}}</v-icon>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-icon small @click="$store.commit('setDeleteDialogStatus', true); $store.commit('setDeleteDialogItem', item)">{{item.delete}}</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card elevation="4">
          <v-card-title>
            View Exist Report
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table :headers="view_record.report_header" :items="report_items" :items-per-page="5" class="elevation-1">
              <template v-slot:item.download="{ item }">
                <a :href="'http://www.genetech.group/static/' + item.report_name + '.pdf'" :download="item.report_name + '.pdf'">
                  <v-icon small>{{item.download}}</v-icon>
                </a>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-icon small @click="$store.commit('setDeleteDialogStatus', true); $store.commit('setDeleteDialogItem', item)">{{item.delete}}</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <deleteDialog/>
    <editDialog/>
  </v-container>
</template>

<script>
import deleteDialog from '../../components/dialog/deleteDialog'
import editDialog from '../../components/dialog/editDialog'
export default {
  name: 'view_record',
  components: {
    deleteDialog,
    editDialog
  },
  computed: {
    import_record_items () {
      return this.view_record.items.filter(item =>
        item.open_id.includes(this.view_record.search_value) ||
        item.FamilyGTLCode.toString().includes(this.view_record.search_value) ||
        item.MemberGTLCode.toString().includes(this.view_record.search_value) ||
        item.AgentGTLCode.toString().includes(this.view_record.search_value) ||
        item.display_name.includes(this.view_record.search_value) ||
        item.MemberEmailID.includes(this.view_record.search_value) ||
        item.total_report.toString().includes(this.view_record.search_value) ||
        item.counter.toString().includes(this.view_record.search_value) ||
        item.last_open_date.toString().includes(this.view_record.search_value) ||
        this.view_record.search_value === ''
      )
    },
    users_items () {
      return this.view_record.users_items.filter(item =>
        item.client_id.includes(this.view_record.search_value) ||
        item.MemberGTLCode.toString().includes(this.view_record.search_value) ||
        item.FamilyGTLCode.toString().includes(this.view_record.search_value) ||
        item.AgentGTLCode.toString().includes(this.view_record.search_value) ||
        item.display_name.includes(this.view_record.search_value) ||
        item.last_name.includes(this.view_record.search_value) ||
        item.first_name.includes(this.view_record.search_value) ||
        item.contact_email.includes(this.view_record.search_value) ||
        item.mobile_number.includes(this.view_record.search_value) ||
        item.wechatID.includes(this.view_record.search_value) ||
        item.dob.includes(this.view_record.search_value) ||
        item.gender.includes(this.view_record.search_value) ||
        item.nationality.includes(this.view_record.search_value) ||
        item.race.includes(this.view_record.search_value) ||
        item.weight.toString().includes(this.view_record.search_value) ||
        item.address.includes(this.view_record.search_value) ||
        item.display_lang.includes(this.view_record.search_value) ||
        this.view_record.search_value === ''
      )
    },
    report_items () {
      return this.view_record.report_items.filter(item =>
        item.essential_id.includes(this.view_record.search_value) ||
        item.open_id.includes(this.view_record.search_value) ||
        item.client_id.includes(this.view_record.search_value) ||
        item.report_name.includes(this.view_record.search_value) ||
        item.SalesGTLCode.includes(this.view_record.search_value) ||
        item.download.includes(this.view_record.search_value) ||
        this.view_record.search_value === ''
      )
    }
  },
  data: () => ({
    view_record: {}
  }),
  created () {
    this.asyn_data()
    this.view_record = this.$store.state.viewRecord
    this.view_record.asyn_data = this.asyn_data
  },
  methods: {
    asyn_data () {
      this.$apis.readImportRecords().then(res => {
        let result = []
        res.data.data.forEach(item => {
          result.push({
            display_name: item.display_name,
            open_id: item.open_id,
            MemberGTLCode: item.MemberGTLCode,
            FamilyGTLCode: item.FamilyGTLCode,
            AgentGTLCode: item.AgentGTLCode,
            MemberEmailID: item.MemberEmailID,
            total_report: item.total_report,
            counter: item.counter,
            last_open_date: item.last_open_date
          })
        })
        this.$store.commit('setViewRecordItem', result)
      })
      this.$apis.readAdditionalInformation().then(res => {
        let result = []
        res.data.data.forEach(item => {
          item.edit = 'far fa-edit'
          item.delete = 'far fa-trash-alt'
          result.push(item)
        })
        this.$store.commit('setUsersItem', result)
      })
      this.$apis.readEssential().then(res => {
        let result = []
        res.data.data.forEach(item => {
          item.download = 'far fa-file-pdf'
          item.delete = 'far fa-trash-alt'
          result.push(item)
        })
        this.$store.commit('setReportItem', result)
      })
    },
    editData (item, type) {
      if (type === 'Client') {
        this.$apis.readInternalIds().then(res => {
          let result = res.data.data.find(e => e.client_id === item.client_id)
          item.internal_id = result.internal_id
          item.MemberGTLCode = result.MemberGTLCode
          item.FamilyGTLCode = result.FamilyGTLCode
          item.AgentGTLCode = result.AgentGTLCode
          item.MemberWIXID = result.MemberWIXID
          item.MemberEmailID = result.MemberEmailID
          this.$store.commit('setEditDialogClient', item)
        })
      }
      this.$store.commit('setEditDialogType', type)
    },
    download_pdf: function (report, reportName, item) {
      // const linkSource = `data:application/pdf;base64,${report}`
      const linkSource = 'http://www.genetech.group/static/' + reportName + '.pdf'
      const downloadLink = document.createElement('a')
      const fileName = reportName + `.pdf`

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    }
  }
}
</script>
